/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.vetting.rpc.AppealStateService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAppealStateForScopeRpc = {
  serviceName: 'com.hubspot.vetting.rpc.AppealStateService',
  rpcName: 'getAppealStateForScope',
  auth: 'app',
  fingerprint: '7j2aUlndVjmCjSykv9xBupwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};